<div class="login-pane">
    <h1>{{ isSignupMode() ? 'Create Account' : 'Login' }}</h1>

    <ng-container *ngIf="oauthProviders.length && !isSignupMode()">
        <div class="oauth-providers">
            <button *ngFor="let p of oauthProviders"
                    mat-stroked-button
                    class="oauth-button"
                    [attr.data-provider]="p.id"
                    [disabled]="loading()"
                    (click)="loginWith(p.id)">
                Sign in with {{ p.displayName }}
            </button>
        </div>
        <div class="oauth-divider"><span>or</span></div>
    </ng-container>

    <mat-form-field>
        <mat-label>{{ isSignupMode() ? 'Email or Username' : 'Email' }}</mat-label>
        <input matInput [(ngModel)]="formUserEmail" type="email" autocomplete="email">
    </mat-form-field>

    <p class="email-hint" *ngIf="isSignupMode()">
        Can be a username instead of an email, but without a real email password recovery, notifications, and other future features won't be available.
    </p>

    <mat-form-field *ngIf="isSignupMode()">
        <mat-label>Display Name (optional)</mat-label>
        <input matInput [(ngModel)]="formDisplayName" type="text" autocomplete="name">
    </mat-form-field>

    <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput [(ngModel)]="formUserPassword" type="password"
               [autocomplete]="isSignupMode() ? 'new-password' : 'current-password'">
    </mat-form-field>

    <mat-form-field *ngIf="isSignupMode()">
        <mat-label>Confirm Password</mat-label>
        <input matInput [(ngModel)]="formConfirmPassword" type="password" autocomplete="new-password">
    </mat-form-field>

    <p class="password-hint" *ngIf="isSignupMode() && formUserPassword && formUserPassword.length < 6">
        Password must be at least 6 characters.
    </p>
    <p class="password-hint" *ngIf="isSignupMode() && formConfirmPassword && formUserPassword !== formConfirmPassword">
        Passwords do not match.
    </p>

    <p class="status-message" *ngIf="statusMessage()">{{ statusMessage() }}</p>
    <p class="error-message" *ngIf="message()">{{ message() }}</p>

    <button *ngIf="!isSignupMode()" mat-raised-button color="primary" (click)="login()"
        [disabled]="!formUserPassword || !formUserEmail || loading()">
        {{ loading() ? 'Logging in...' : 'Login' }}
    </button>

    <button *ngIf="isSignupMode()" mat-raised-button color="primary" (click)="signup()"
        [disabled]="!canSignup()">
        {{ loading() ? 'Creating account...' : 'Create Account' }}
    </button>

    <p class="mode-toggle">
        <span *ngIf="!isSignupMode()">Don't have an account? <a (click)="toggleMode()">Create one</a></span>
        <span *ngIf="isSignupMode()">Already have an account? <a (click)="toggleMode()">Login</a></span>
    </p>
</div>
